import React from "react";
import Typography from "@material-ui/core/Typography";
const ItemPackage = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Item Package
      </Typography>
      <Typography paragraph variant="h5">
        Combine some products into single package for special event
      </Typography>
      <Typography paragraph variant="body1">
        Item Package is one of the features under the Sales module to manage and
        combine some items into a single selling package for particular events
        like New Year, Big Sale, etc. It contains any information regarding the
        package name, package active duration, package price, and item
        components inside the package.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Item Package
        list. It is displayed like a table that contains download functions,
        sort, filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Package ID</b>
        <br />
        Indicates the ID of the Package.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Package Code</b>
        <br />
        Indicates the code of the Package.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Package Name</b>
        <br />
        Indicates the name of the Package.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Start Date</b>
        <br />
        Indicates the active duration start date of the Package.
      </Typography>
      <Typography paragraph variant="body1">
        <b>End Date</b>
        <br />
        Indicates the active duration end date of the Package.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Package Status</b>
        <br />
        Indicates the status of the Package. There are 2 statuses: Active and
        Expired.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Package Price</b>
        <br />
        Indicates the total price of the Package.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of Item Package
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Item Package</b>
        <br />
        This button is used to edit the Item Package data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Package Detail</b>
        <br />
        This button is used to navigate to the Item Package detail in
        non-editable mode.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Item Package</b>
        <br />
        This button is used to delete the Item Package data. The Item Package
        data is undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default ItemPackage;
